import styled from 'styled-components'
import { Theme } from 'styles/Themes'
import { PopUpState } from '.'

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #cccccc80;
`
export const PopUpContent = styled.div<{ popUpState: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  width: 568px;
  top: 50%;
  left: 50%;
  gap: 32px;
  transform: translate(-50%, -50%);
  box-shadow: 0px 0px 24px 0px #00000029;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 40px;
  .title-container {
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }
  .title {
    font-family: Inter;
    font-size: 24px;
    font-weight: 700;
    line-height: 28.8px;

    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: center;
    filter: ${({ popUpState }) =>
      popUpState === PopUpState.BLOCKED || popUpState === PopUpState.FAILED
        ? 'brightness(0) saturate(100%) invert(11%) sepia(98%) saturate(6889%) hue-rotate(5deg) brightness(97%) contrast(113%)'
        : 'none'};
  }
  .title-icon {
    width: 24px;
  }
  .subtitle {
    font-family: Inter;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.2px;
    color: #1c1d22;
  }
  .button-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .send-pin-container {
    border: none;
    align-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 700;
    color: #757575;
  }
  .send-pin-btn {
    font-size: 14px;
    font-weight: 700;
    background-color: transparent;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    gap: 8px;
    display: flex;
    border: none;
  }
  .resend-icon {
    width: 16px;
  }
`

export const FeedbackIcon = styled.img<{ popUpState: number }>`
  width: 120px;
  filter: ${({ popUpState }) =>
    popUpState === PopUpState.BLOCKED || popUpState === PopUpState.FAILED
      ? 'brightness(0) saturate(100%) invert(11%) sepia(98%) saturate(6889%) hue-rotate(5deg) brightness(97%) contrast(113%)'
      : ''};
`

export const InputContainer = styled.div<{ hasError: boolean }>`
  display: flex;
  flex-direction: column;
  align-self: center;
  .otp-container {
    display: flex;
    justify-content: center;
    gap: 12px;
    width: 100%;
  }
  .input-style {
    width: 80px !important;
    height: 80px;
    font-size: 48px;
    font-weight: 500;
    border-radius: 8px;
    border: 1px solid ${({ hasError }) => (hasError ? '#ff0000' : '#757575')};
    transition: all 0.3s ease;
    &:focus {
      border-color: ${({ hasError }) => (hasError ? '#ff0000' : 'black')};
      outline: none; /* Remove o outline padrão */
      box-shadow: 0 0 0 2px #00000028; /* Adiciona uma borda ao redor do input */
    }
  }
`

export const ErrorMsg = styled.div<{ showErrror: boolean }>`
  font-family: ${Theme.fontFamily.SECONDARY};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  width: 100%;
  max-width: 360px;
  color: ${Theme.pallete.SENARY};
  opacity: ${(props) => (props.showErrror ? 1 : 0)};
  .msg-icon {
    width: 16px;
    height: 16px;
    filter: brightness(0) saturate(100%) invert(11%) sepia(98%) saturate(6889%)
      hue-rotate(5deg) brightness(97%) contrast(113%);
  }
  margin-bottom: 16px;
`
